module.exports = __webpack_public_path__ + "img/index-pro-01.0bda29eb.png";